export const iOS = 'iOS'

export const Android = 'Android'

export const OSX = 'OS X'

export const Safari = 'Safari'

export const Chrome = 'Chrome'